import type { Color } from '../../config';

export const DOCUMENT_COLORS = {
  black: { hex: '#000000', int: 0x000000 },
  darkGray: { hex: '#333333', int: 0x333333 },
  gray: { hex: '#808080', int: 0x808080 },
  lightGray: { hex: '#B7B7B7', int: 0xb7b7b7 },
  silver: { hex: '#D3D3D3', int: 0xd3d3d3 },
  white: { hex: '#FFFFFF', int: 0xffffff },
  darkRed: { hex: '#700303', int: 0x700303 },
  red: { hex: '#B7202F', int: 0xb7202f },
  brightRed: { hex: '#E80505', int: 0xe80505 },
  darkBlue: { hex: '#003366', int: 0x003366 },
  blue: { hex: '#1A3E94', int: 0x1a3e94 },
  darkGreen: { hex: '#008000', int: 0x008000 },
  peach: { hex: '#FFCC99', int: 0xffcc99 },
  lightYellow: { hex: '#FFFF99', int: 0xffff99 },
} as const;

const intToHexMap = new Map<Color, string>(Object.values(DOCUMENT_COLORS).map((color) => [color.int, color.hex]));
const hexToIntMap = new Map<string, Color>(Object.values(DOCUMENT_COLORS).map((color) => [color.hex, color.int]));

export const DOCUMENT_COLOR_VALUES: string[] = Object.values(DOCUMENT_COLORS).map((color) => color.hex);

const DEFAULT_VALUE = 'transparent';

export const intToHex = (value?: Color): string => {
  if (value === undefined) {
    return DEFAULT_VALUE;
  }
  // to support string values in old templates
  if (typeof value === 'string') {
    return value;
  }
  return intToHexMap.get(value) || DEFAULT_VALUE;
};

export const hexToInt = (color: string): Color | undefined => hexToIntMap.get(color);
